import {DOSSIER_STATE} from 'front-onceforall-core/dist/utils/dossiers';
import {DOCUMENT_STATE} from 'front-onceforall-core/dist/utils/documents';
import {COUNTRY} from 'front-onceforall-core/dist/utils/country';

// eslint-disable-next-line import/no-mutable-exports
export let documentsInDb = [{
  uid: 'f81d4fae-7dec-11d0-a765-00a0c91e6bf6',
  state: 'MISSING',
  type: {
    documentTypeId: 26,
    code: 'TAX_LIABILITY',
    name: 'Nachweis Steuerschuldnerschaft',
    hasExample: true,
    country: COUNTRY.GERMANY,
    dossier: 'BUSINESS'
  },
  validityEnd: null,
  hasFile: false,
  userId: '9231a32d-1163-444d-8587-e2680ee4a3aa',
  dossiers: [{
    type: 'BUSINESS',
    business: 'CONSTRUCTION'
  }],
  rejectionReason: null,
  additionalDesignation: null,
  almostExpired: false,
  collectionMandateEnabled: false,
  unpublished: false,
  correlationId: 1,
  overallStatusDocument: true
},
{
  uid: 'f81d4fae-7dec-11d0-a765-00a0c91e6bf7',
  state: 'MISSING',
  type: {
    documentTypeId: 3,
    code: 'REG_TRADE',
    name: 'Handelsregisterauszug',
    hasExample: true,
    country: COUNTRY.GERMANY,
    dossier: 'LEGAL'
  },
  validityEnd: '2018-03-01T08:41:32.957Z',
  hasFile: false,
  userId: '9231a32d-1163-444d-8587-e2680ee4a3aa',
  dossiers: [{
    type: 'LEGAL'
  }],
  rejectionReason: 'Some reason',
  additionalDesignation: 'Ich bin ein Kartofel salad',
  almostExpired: false,
  collectionMandateEnabled: true,
  unpublished: false,
  correlationId: 2,
  overallStatusDocument: true
},
{
  uid: 'f81d4fae-7dec-11d0-a765-00a0c91e6b90',
  state: 'AWAITING_SIGNATURE',
  type: {
    documentTypeId: 3,
    code: 'FOREIGN_EMPLOYEES',
    name: 'Liste des salariés étrangers soumis à autorisation de travail',
    hasExample: false,
    country: COUNTRY.FRANCE,
    dossier: 'LEGAL'
  },
  validityEnd: '2018-03-01T08:41:32.957Z',
  hasFile: false,
  hasExcelFile: true,
  userId: '9231a32d-1163-444d-8587-e2680ee4a3aa',
  dossiers: [{
    type: 'LEGAL'
  }],
  rejectionReason: 'Some reason',
  additionalDesignation: 'Ich bin ein Kartofel salad',
  almostExpired: false,
  collectionMandateEnabled: false,
  unpublished: false,
  correlationId: 3,
  overallStatusDocument: true
},
{
  uid: 'f81d4fae-7dec-11d0-a765-00a0c91a6b30',
  correlationId: 'f81d4fae-7dec-11d0-a765-00a0c91a6b30',
  groupLevel: true,
  state: 'AWAITING_SIGNATURE',
  type: {
    documentTypeId: 313,
    name: 'Attestation sur l\'honneur',
    code: 'ADD_SWORN_STAT',
    parentCode: 'ADDITIONAL',
    parentName: 'Attestation de mutuelle / prévoyance / retraite',
    multiOccurrence: false,
    validityPeriod: 6,
    abstractType: false,
    hasExample: false,
    applicationLevel: 'GROUP',
    onlyForProjectSubcontractor: false,
    gatheredByDepositor: true,
    collectableByMandate: false,
    equivalence: {
      code: 'FR_SWORN',
      rule: 'UNIQUE'
    },
    canBeAdded: true,
    dossier: 'ADDITIONAL',
    country: COUNTRY.FRANCE,
    legacy: false,
    obligationConfiguration: 'UNAVAILABLE'
  },
  depositDate: null,
  organisations: [
    {
      organisationId: 1,
      fullName: 'Organisation 1',
      country: COUNTRY.FRANCE,
      businessLine: 'CONSTRUCTION',
      address: {
        addressLine: '50, rue de l\'oie',
        city: 'Lyon',
        postCode: '69300'
      },
      registrationNumber: '12345678901234',
      depositor: true,
      group: {
        id: 900,
        country: COUNTRY.FRANCE,
        groupIdentifier: '123456789'
      },
      enabled: true
    }
  ],
  validityEnd: null,
  hasFile: false,
  md5: null,
  hasExcelFile: false,
  noticePeriodConfiguration: 'MEDIUM',
  firstNoticePeriod: 30,
  secondNoticePeriod: 15,
  thirdNoticePeriod: 5,
  issueDate: null,
  validityStart: null,
  certifyingThirdParty: null,
  certifyingThirdPartyId: null,
  issuingThirdParty: null,
  issuingThirdPartyId: null,
  thirdPartyIdNumber: null,
  rejectionReason: null,
  additionalDesignation: null,
  verificationCode: null,
  referencePeriod: null,
  referenceYear: null,
  payroll: null,
  staff: null,
  withCapitalizationScheme: false,
  amountBankGuarantee: null,
  turnover: null,
  iban: null,
  bic: null,
  contributionRate: null,
  turnoverTwa: null,
  subjectToObligation: true,
  gatheredByDepositor: true,
  collectionMandateEnabled: false,
  toFillinOnline: false,
  toSignOnline: true,
  hasProofFile: false,
  dossiers: [],
  unpublished: false,
  overallStatusDocument: true
},
{
  uid: 'f81d4fae-7dec-11d0-a765-30a0c91a6c44',
  correlationId: 'f81d4fae-7dec-11d0-a765-30a0c91a6c44',
  groupLevel: true,
  state: 'SIGNED',
  type: {
    documentTypeId: 313,
    name: 'Attestation sur l\'honneur',
    code: 'ADD_SWORN_STAT',
    parentCode: 'ADDITIONAL',
    parentName: 'Attestation de mutuelle / prévoyance / retraite',
    multiOccurrence: false,
    validityPeriod: 6,
    abstractType: false,
    hasExample: false,
    applicationLevel: 'GROUP',
    onlyForProjectSubcontractor: false,
    gatheredByDepositor: true,
    collectableByMandate: false,
    equivalence: {
      code: 'FR_SWORN',
      rule: 'UNIQUE'
    },
    canBeAdded: true,
    dossier: 'ADDITIONAL',
    country: COUNTRY.FRANCE,
    legacy: false,
    obligationConfiguration: 'UNAVAILABLE'
  },
  depositDate: '2019-09-26T10:00:00.000Z',
  organisations: [
    {
      organisationId: 1,
      fullName: 'Organisation 1',
      country: COUNTRY.FRANCE,
      businessLine: 'CONSTRUCTION',
      address: {
        addressLine: '50, rue de l\'oie',
        city: 'Lyon',
        postCode: '69300'
      },
      registrationNumber: '12345678901234',
      depositor: true,
      group: {
        id: 900,
        country: COUNTRY.FRANCE,
        groupIdentifier: '123456789'
      },
      enabled: true
    }
  ],
  validityEnd: '2030-12-26T10:00:00.000Z',
  hasFile: true,
  md5: 'a50419318ee16ddccfe50dd3566e2aee',
  hasExcelFile: false,
  noticePeriodConfiguration: 'MEDIUM',
  firstNoticePeriod: 30,
  secondNoticePeriod: 15,
  thirdNoticePeriod: 5,
  issueDate: '2019-09-26T10:00:00.000Z',
  validityStart: '2030-09-26T10:00:00.000Z',
  certifyingThirdParty: null,
  certifyingThirdPartyId: null,
  issuingThirdParty: null,
  issuingThirdPartyId: null,
  thirdPartyIdNumber: null,
  rejectionReason: null,
  additionalDesignation: 'IN THE FUTURE',
  verificationCode: null,
  referencePeriod: null,
  referenceYear: null,
  payroll: null,
  staff: null,
  withCapitalizationScheme: false,
  amountBankGuarantee: null,
  turnover: null,
  iban: null,
  bic: null,
  contributionRate: null,
  turnoverTwa: null,
  subjectToObligation: true,
  gatheredByDepositor: true,
  collectionMandateEnabled: false,
  toFillinOnline: false,
  toSignOnline: true,
  hasProofFile: false,
  dossiers: [],
  unpublished: false,
  overallStatusDocument: true
},
{
  uid: 'f81d4fae-7dec-11d0-a765-00a0c91e6bf8',
  state: 'AWAITING_COMPLETION',
  type: {
    documentTypeId: 18,
    code: 'EXT_SAFETY_INFO',
    name: 'Auskunft Arbeitssicherheit',
    multiOccurrence: true,
    hasExample: true,
    country: COUNTRY.GERMANY,
    dossier: 'ADDITIONAL'
  },
  validityEnd: '2018-03-01T08:41:32.957Z',
  hasFile: true,
  userId: '9231a32d-1163-444d-8587-e2680ee4a3aa',
  dossiers: [{
    type: 'LEGAL'
  }],
  rejectionReason: null,
  additionalDesignation: 'Ich bin ein Kartofel salad',
  almostExpired: false,
  collectionMandateEnabled: false,
  unpublished: false,
  correlationId: 4,
  overallStatusDocument: true
},
{
  uid: 'f81d4fae-7dec-11d0-a765-00a0c91e6bf9',
  state: 'AWAITING_SIGNATURE',
  type: {
    documentTypeId: 19,
    code: 'EMPLOYEES',
    name: 'Liste der eingesetzten Arbeitnehmer',
    hasExample: true,
    country: COUNTRY.GERMANY,
    dossier: 'ADDITIONAL'
  },
  validityEnd: '2018-03-01T08:41:32.957Z',
  hasFile: true,
  userId: '9231a32d-1163-444d-8587-e2680ee4a3aa',
  dossiers: [{
    type: 'BUSINESS',
    business: 'CONSTRUCTION'
  }],
  rejectionReason: null,
  almostExpired: false,
  collectionMandateEnabled: false,
  unpublished: false,
  correlationId: 5,
  overallStatusDocument: true
},
{
  uid: 'f81d4fae-7dec-11d0-a765-00a0c91e6bfa',
  state: 'VALID',
  type: {
    documentTypeId: 1,
    code: 'TAX_OFFICE',
    name: 'Finanzamt-Bescheinigung',
    hasExample: true,
    country: COUNTRY.GERMANY,
    dossier: 'LEGAL'
  },
  validityStart: '2021-03-01T08:41:32.957Z',
  validityEnd: '2021-09-01T08:41:32.957Z',
  hasFile: true,
  userId: '9231a32d-1163-444d-8587-e2680ee4a3aa',
  dossiers: [{
    type: 'PROJECT',
    project: {
      interventionId: 10,
      projectId: 42,
      name: 'Incity',
      ownerOrganisation: {
        organisationId: 2,
        fullName: 'ALG'
      }
    }
  },
  {
    type: 'RELATIONSHIP',
    client: {
      organisationId: 2,
      fullName: 'ALG'
    }
  },
  {
    type: 'LEGAL'
  }],
  rejectionReason: null,
  almostExpired: false,
  collectionMandateEnabled: true,
  unpublished: false,
  correlationId: 6,
  overallStatusDocument: true
},
{
  uid: 'f81d4fae-7dec-11d0-a765-00a0c91e6bfb',
  state: 'AWAITING_VALIDATION',
  type: {
    documentTypeId: 7,
    code: 'PE_HEALTH',
    name: 'Krankenkassen (Unbedenklichkeitsbescheinigung)',
    hasExample: true,
    country: COUNTRY.GERMANY,
    dossier: 'LEGAL'
  },
  validityEnd: '2018-03-01T08:41:32.957Z',
  hasFile: true,
  userId: '9231a32d-1163-444d-8587-e2680ee4a3aa',
  dossiers: [{
    type: 'PROJECT',
    project: {
      interventionId: 11,
      projectId: 42,
      name: 'Incity',
      ownerOrganisation: {
        organisationId: 2,
        fullName: 'ALG'
      }
    }
  },
  {
    type: 'PROJECT',
    project: {
      interventionId: 12,
      projectId: 43,
      name: 'Medipôle',
      ownerOrganisation: {
        organisationId: 2,
        fullName: 'ALG'
      }
    }
  },
  {
    type: 'RELATIONSHIP',
    client: {
      organisationId: 2,
      fullName: 'ALG'
    }
  }],
  rejectionReason: null,
  additionalDesignation: 'Wunderbar certifikat',
  almostExpired: false,
  collectionMandateEnabled: true,
  unpublished: false,
  correlationId: 7,
  overallStatusDocument: true
},
{
  uid: 'f81d4fae-7dec-11d0-a765-00a0c91e6bfc',
  state: 'NOT_APPLICABLE',
  type: {
    documentTypeId: 14,
    code: 'EXT_SPECIALIST',
    name: 'Fachbetriebsbescheinigungen',
    hasExample: true,
    country: COUNTRY.GERMANY,
    dossier: 'ADDITIONAL'
  },
  validityEnd: '2018-03-01T08:41:32.957Z',
  hasFile: true,
  userId: '9231a32d-1163-444d-8587-e2680ee4a3aa',
  dossiers: [{
    type: 'RELATIONSHIP',
    client: {
      organisationId: 2,
      fullName: 'ALG'
    }
  },
  {
    type: 'RELATIONSHIP',
    client: {
      organisationId: 3,
      fullName: 'D&S'
    }
  }],
  rejectionReason: null,
  additionalDesignation: 'Wunderbar dokument',
  almostExpired: false,
  collectionMandateEnabled: false,
  unpublished: false,
  correlationId: 8,
  overallStatusDocument: true
},
{
  uid: 'f81d4fae-7dec-11d0-a765-00a0c91e6bfd',
  state: 'AWAITING_GATHERING',
  type: {
    documentTypeId: 20,
    code: 'COV_WAGE',
    name: 'Mindestlohn- / Tariftreueerkl.',
    hasExample: true,
    country: COUNTRY.GERMANY,
    dossier: 'LEGAL'
  },
  validityEnd: '2018-03-01T08:41:32.957Z',
  hasFile: false,
  userId: '9231a32d-1163-444d-8587-e2680ee4a3aa',
  dossiers: [{
    type: 'LEGAL'
  }],
  rejectionReason: null,
  almostExpired: false,
  collectionMandateEnabled: true,
  unpublished: false,
  correlationId: 9,
  overallStatusDocument: true
},
{
  uid: 'f81d4fae-7dec-11d0-a765-00a0c91e6bfe',
  state: 'CREATED',
  type: {
    documentTypeId: 11,
    code: 'INS_ASSOCIATION',
    name: 'Berufsgenossenschaft (Qualifizierende Unbedenklichkeitsbescheinigung)',
    hasExample: true,
    country: COUNTRY.GERMANY,
    dossier: 'LEGAL'
  },
  validityEnd: '2018-03-01T08:41:32.957Z',
  hasFile: false,
  userId: '9231a32d-1163-444d-8587-e2680ee4a3aa',
  dossiers: [{
    type: 'LEGAL'
  },
  {
    type: 'PROJECT',
    project: {
      interventionId: 13,
      projectId: 44,
      name: 'Project',
      ownerOrganisation: {
        organisationId: 2,
        fullName: 'ALG'
      }
    }
  },
  {
    type: 'RELATIONSHIP',
    client: {
      organisationId: 4,
      fullName: 'Relationship'
    }
  }],
  rejectionReason: 'Some quite long reason in order to test the overflow mecanism and again and again and again and again and again and again and again and again and again and again and again and again',
  almostExpired: false,
  unpublished: false,
  correlationId: 11,
  overallStatusDocument: true
},
{
  uid: 'f81d4fae-7dec-11d8-a764-00a0c91e6bd7',
  state: 'VALID',
  type: {
    documentTypeId: 3,
    code: 'REG_TRADE',
    name: 'Handelsregisterauszug',
    validityPeriod: 12,
    hasExample: true,
    country: COUNTRY.GERMANY,
    dossier: 'LEGAL'
  },
  validityEnd: '2018-03-01T08:41:32.957Z',
  hasFile: true,
  userId: '9231a32d-1163-444d-8587-e2680ee4a3aa',
  dossiers: [{
    type: 'LEGAL'
  }],
  rejectionReason: null,
  additionalDesignation: 'Ich bin ein Kartofel salad',
  almostExpired: false,
  unpublished: false,
  correlationId: 12,
  overallStatusDocument: true
},
{
  uid: 'f81d4fae-8dec-12d8-a765-00a0r91e6bd7',
  state: 'MISSING',
  type: {
    documentTypeId: 3,
    code: 'REG_TRADE',
    name: 'Handelsregisterauszug',
    validityPeriod: 12,
    designationMandatory: true,
    hasExample: true,
    country: COUNTRY.GERMANY,
    dossier: 'LEGAL'
  },
  validityEnd: '2018-03-01T08:41:32.957Z',
  hasFile: false,
  userId: '9231a32d-1163-444d-8587-e2680ee4a3aa',
  dossiers: [{
    type: 'LEGAL'
  }],
  rejectionReason: 'Some reason',
  additionalDesignation: 'Ich bin ein Kartofel salad',
  almostExpired: false,
  unpublished: false,
  correlationId: 12,
  overallStatusDocument: false
},
{
  uid: 'f81d4fae-9dec-12d8-a765-00a0r91e6bd7',
  state: 'MISSING',
  type: {
    documentTypeId: 25,
    code: 'DE_SOKA',
    name: 'SOKA Bau ULAK / Negativbescheinigung',
    validityPeriod: null,
    designationMandatory: false,
    hasExample: true,
    country: COUNTRY.GERMANY,
    dossier: 'BUSINESS'
  },
  validityEnd: null,
  hasFile: false,
  userId: '9231a32d-1163-444d-8587-e2680ee4a3aa',
  dossiers: [{
    type: 'BUSINESS',
    business: 'CONSTRUCTION'
  }],
  rejectionReason: null,
  additionalDesignation: null,
  almostExpired: false,
  unpublished: true,
  correlationId: 14,
  overallStatusDocument: true
},
{
  uid: 'f99f2a89-a480-45a8-8ef5-9331276b51c4',
  correlationId: '928b2547-42c7-4eab-9fcd-1f5488800591',
  apiExternalId: 9615,
  legacyExternalId: 2004174,
  groupLevel: true,
  state: 'REJECTED',
  type: {
    documentTypeId: 46,
    name: "Attestation Décennale Standard En qualité d'E.P.E.R.S.",
    code: 'INS_DEC_EPERS',
    parentCode: 'INSURANCE',
    parentName: "Attestation d'assurance",
    multiOccurrence: false,
    validityPeriod: null,
    abstractType: false,
    hasExample: false,
    applicationLevel: 'GROUP',
    onlyForProjectSubcontractor: false,
    gatheredByDepositor: true,
    collectableByMandate: true,
    equivalence: {
      code: 'FR_INS_DEC',
      rule: 'UNIQUE'
    },
    canBeAdded: true,
    dossier: 'BUSINESS',
    country: 'FRANCE',
    legacy: false,
    obligationConfiguration: 'UNAVAILABLE'
  },
  depositDate: '2020-12-29T14:50:41.787Z',
  organisations: [
    {
      organisationId: 12701,
      fullName: 'Mian Sécurité',
      country: 'FRANCE',
      businessLine: 'SAFETY',
      address: {
        addressLine: '464 Boulevard Saint Vincent',
        city: 'Lyon',
        postCode: '69246'
      },
      registrationNumber: '42142142100002',
      registrationDate: null,
      depositor: true,
      groupId: 3104,
      enabled: true,
      headquarter: false,
      groupNumber: '421421421',
      organisationType: 'DEFAULT',
      identificationNumbers: null
    }
  ],
  validityStart: null,
  validityEnd: null,
  hasFile: true,
  md5: '0eb12b10ae7065007c085652433ae12b',
  hasExcelFile: false,
  noticePeriodConfiguration: 'MEDIUM',
  firstNoticePeriod: 30,
  secondNoticePeriod: 15,
  thirdNoticePeriod: 5,
  issueDate: null,
  certifyingThirdParty: null,
  certifyingThirdPartyId: null,
  issuingThirdParty: null,
  issuingThirdPartyId: null,
  thirdPartyIdNumber: null,
  rejectionReason: null,
  additionalDesignation: 'wow',
  verificationCode: null,
  referencePeriod: null,
  referenceYear: null,
  payroll: null,
  staff: null,
  withCapitalizationScheme: false,
  amountBankGuarantee: null,
  turnover: null,
  iban: null,
  bic: null,
  contributionRate: null,
  turnoverTwa: null,
  subjectToObligation: true,
  gatheredByDepositor: true,
  collectionMandateEnabled: false,
  toFillinOnline: false,
  toSignOnline: false,
  md5Proof: null,
  hasProofFile: false,
  dossiers: [
    {
      type: 'BUSINESS',
      project: null,
      business: 'CONSTRUCTION'
    }
  ],
  unpublished: false,
  overallStatusDocument: true,
  projectContext: [
    {
      projectId: 1,
      projectOpeningDate: '2019-10-27T23:00:00Z',
      state: 'REJECTED'
    }
  ]
}];

const archivedDocumentsInDb = Object.assign(
  [],
  [
    {
      uid: '64a1d909-4707-49eb-9527-be0b96397f04',
      groupLevel: false,
      state: 'VALID',
      type: {
        documentTypeId: 3,
        name: 'Handelsregisterauszug',
        code: 'REG_TRADE',
        parentCode: 'REGISTRATION',
        parentName: 'Registrierungsnachweis',
        multiOccurrence: false,
        validityPeriod: 12,
        designationMandatory: false,
        abstractType: false,
        hasExample: true,
        applicationLevel: 'ORGANISATION',
        certifyingThirdPartyMandatory: false,
        onlyForProjectSubcontractor: false,
        collectableByMandate: false,
        equivalence: null,
        country: COUNTRY.GERMANY
      },
      depositDate: '2019-05-08T11:37:35.897Z',
      organisations: [
        {
          organisationId: 2552,
          fullName: 'Raison',
          country: COUNTRY.GERMANY,
          address: {
            addressLine: 'Ad',
            city: 'Vi',
            postCode: '332211'
          },
          registrationNumber: '33442211',
          depositor: true,
          group: {
            id: 2651,
            country: COUNTRY.GERMANY,
            groupIdentifier: 'DE334422113'
          }
        }
      ],
      validityEnd: '2021-10-06T22:59:59.999Z',
      hasFile: true,
      hasExcelFile: false,
      noticePeriodConfiguration: 'MEDIUM',
      firstNoticePeriod: 30,
      secondNoticePeriod: 15,
      thirdNoticePeriod: 5,
      issueDate: '2021-05-08T11:37:28.438Z',
      validityStart: '2021-05-08T11:37:28.438Z',
      certifyingThirdParty: null,
      issuingThirdParty: null,
      rejectionReason: null,
      additionalDesignation: '',
      subjectToObligation: true,
      collectableByMandate: false,
      collectionMandateEnabled: false,
      toFillinOnline: false,
      toSignOnline: false,
      dossiers: [
        {
          type: 'LEGAL',
          client: null,
          project: null,
          business: null
        }
      ],
      unpublished: true,
      overallStatusDocument: false
    },
    {
      uid: '7ff1c37d-85d4-4106-a0e1-77b716560adc',
      groupLevel: false,
      state: 'VALID',
      type: {
        documentTypeId: 3,
        name: 'Handelsregisterauszug',
        code: 'REG_TRADE',
        parentCode: 'REGISTRATION',
        parentName: 'Registrierungsnachweis',
        multiOccurrence: false,
        validityPeriod: 12,
        designationMandatory: false,
        abstractType: false,
        hasExample: true,
        applicationLevel: 'ORGANISATION',
        certifyingThirdPartyMandatory: false,
        onlyForProjectSubcontractor: false,
        collectableByMandate: false,
        equivalence: null,
        country: COUNTRY.GERMANY
      },
      depositDate: '2019-05-08T11:37:35.897Z',
      organisations: [
        {
          organisationId: 2552,
          fullName: 'Raison',
          country: COUNTRY.GERMANY,
          address: {
            addressLine: 'Ad',
            city: 'Vi',
            postCode: '332211'
          },
          registrationNumber: '33442211',
          depositor: true,
          group: {
            id: 2651,
            country: COUNTRY.GERMANY,
            groupIdentifier: 'DE334422113'
          }
        }
      ],
      validityEnd: '2019-06-10T22:59:59.999Z',
      hasFile: true,
      hasExcelFile: false,
      noticePeriodConfiguration: 'MEDIUM',
      firstNoticePeriod: 30,
      secondNoticePeriod: 15,
      thirdNoticePeriod: 5,
      issueDate: '2019-05-08T11:37:28.438Z',
      validityStart: '2019-05-08T11:37:28.438Z',
      certifyingThirdParty: null,
      issuingThirdParty: null,
      rejectionReason: null,
      additionalDesignation: '',
      subjectToObligation: true,
      collectableByMandate: false,
      collectionMandateEnabled: false,
      toFillinOnline: false,
      toSignOnline: false,
      dossiers: [
        {
          type: 'LEGAL',
          client: null,
          project: null,
          business: null
        }
      ],
      unpublished: true,
      overallStatusDocument: false
    },
    {
      uid: '8bd88a46-f6c1-46c5-aa14-7a57d1f55ec0',
      groupLevel: false,
      state: 'VALID',
      type: {
        documentTypeId: 3,
        name: 'Handelsregisterauszug',
        code: 'REG_TRADE',
        parentCode: 'REGISTRATION',
        parentName: 'Registrierungsnachweis',
        multiOccurrence: false,
        validityPeriod: 12,
        designationMandatory: false,
        abstractType: false,
        hasExample: true,
        applicationLevel: 'ORGANISATION',
        certifyingThirdPartyMandatory: false,
        onlyForProjectSubcontractor: false,
        collectableByMandate: false,
        equivalence: null,
        country: COUNTRY.GERMANY
      },
      depositDate: '2019-05-08T11:37:35.897Z',
      organisations: [
        {
          organisationId: 2552,
          fullName: 'Raison',
          country: COUNTRY.GERMANY,
          address: {
            addressLine: 'Ad',
            city: 'Vi',
            postCode: '332211'
          },
          registrationNumber: '33442211',
          depositor: true,
          group: {
            id: 2651,
            country: COUNTRY.GERMANY,
            groupIdentifier: 'DE334422113'
          }
        }
      ],
      validityEnd: '2019-06-10T22:59:59.999Z',
      hasFile: true,
      hasExcelFile: false,
      noticePeriodConfiguration: 'MEDIUM',
      firstNoticePeriod: 30,
      secondNoticePeriod: 15,
      thirdNoticePeriod: 5,
      issueDate: '2019-05-08T11:37:28.438Z',
      validityStart: '2019-05-08T11:37:28.438Z',
      certifyingThirdParty: null,
      issuingThirdParty: null,
      rejectionReason: null,
      additionalDesignation: '',
      subjectToObligation: true,
      collectableByMandate: false,
      collectionMandateEnabled: false,
      toFillinOnline: false,
      toSignOnline: false,
      dossiers: [
        {
          type: 'LEGAL',
          client: null,
          project: null,
          business: null
        }
      ],
      unpublished: true,
      overallStatusDocument: false
    },
    {
      uid: '120030f4-7e78-48c1-9c43-6e45eac881d6',
      groupLevel: false,
      state: 'VALID',
      type: {
        documentTypeId: 4,
        name: 'Gewerbeanmeldung',
        code: 'REG_BUSINESS',
        parentCode: 'REGISTRATION',
        parentName: 'Registrierungsnachweis',
        multiOccurrence: false,
        validityPeriod: 120,
        designationMandatory: false,
        abstractType: false,
        hasExample: true,
        applicationLevel: 'ORGANISATION',
        certifyingThirdPartyMandatory: false,
        onlyForProjectSubcontractor: false,
        collectableByMandate: false,
        equivalence: null,
        country: COUNTRY.GERMANY
      },
      depositDate: '2019-05-08T11:38:19.097Z',
      organisations: [
        {
          organisationId: 2552,
          fullName: 'Raison',
          country: COUNTRY.GERMANY,
          address: {
            addressLine: 'Ad',
            city: 'Vi',
            postCode: '332211'
          },
          registrationNumber: '33442211',
          depositor: true,
          group: {
            id: 2651,
            country: COUNTRY.GERMANY,
            groupIdentifier: 'DE334422113'
          }
        }
      ],
      validityEnd: '2029-05-08T23:59:59Z',
      hasFile: true,
      hasExcelFile: false,
      noticePeriodConfiguration: 'MEDIUM',
      firstNoticePeriod: 30,
      secondNoticePeriod: 15,
      thirdNoticePeriod: 5,
      issueDate: '2019-05-08T00:00:00Z',
      validityStart: '2022-05-08T00:00:00Z',
      certifyingThirdParty: null,
      issuingThirdParty: null,
      rejectionReason: null,
      additionalDesignation: '',
      subjectToObligation: true,
      collectableByMandate: false,
      collectionMandateEnabled: false,
      toFillinOnline: false,
      toSignOnline: false,
      dossiers: [
        {
          type: 'LEGAL',
          client: null,
          project: null,
          business: null
        }
      ],
      unpublished: true,
      overallStatusDocument: false
    },
    {
      uid: '19dbfd42-8005-4318-a298-1db4588a82b6',
      groupLevel: false,
      state: 'VALID',
      type: {
        documentTypeId: 4,
        name: 'Gewerbeanmeldung',
        code: 'REG_BUSINESS',
        parentCode: 'REGISTRATION',
        parentName: 'Registrierungsnachweis',
        multiOccurrence: false,
        validityPeriod: 120,
        designationMandatory: false,
        abstractType: false,
        hasExample: true,
        applicationLevel: 'ORGANISATION',
        certifyingThirdPartyMandatory: false,
        onlyForProjectSubcontractor: false,
        collectableByMandate: false,
        equivalence: null,
        country: COUNTRY.GERMANY
      },
      depositDate: '2019-05-08T11:38:19.097Z',
      organisations: [
        {
          organisationId: 2552,
          fullName: 'Raison',
          country: COUNTRY.GERMANY,
          address: {
            addressLine: 'Ad',
            city: 'Vi',
            postCode: '332211'
          },
          registrationNumber: '33442211',
          depositor: true,
          group: {
            id: 2651,
            country: COUNTRY.GERMANY,
            groupIdentifier: 'DE334422113'
          }
        }
      ],
      validityEnd: '2019-06-10T22:59:59.999Z',
      hasFile: true,
      hasExcelFile: false,
      noticePeriodConfiguration: 'MEDIUM',
      firstNoticePeriod: 30,
      secondNoticePeriod: 15,
      thirdNoticePeriod: 5,
      issueDate: '2019-05-08T00:00:00Z',
      validityStart: '2019-05-08T00:00:00Z',
      certifyingThirdParty: null,
      issuingThirdParty: null,
      rejectionReason: null,
      additionalDesignation: '',
      subjectToObligation: true,
      collectableByMandate: false,
      collectionMandateEnabled: false,
      toFillinOnline: false,
      toSignOnline: false,
      dossiers: [
        {
          type: 'LEGAL',
          client: null,
          project: null,
          business: null
        }
      ],
      unpublished: true,
      overallStatusDocument: false
    },
    {
      uid: '348d799a-642a-4843-9b7d-89ebb9b46477',
      groupLevel: false,
      state: 'VALID',
      type: {
        documentTypeId: 4,
        name: 'Gewerbeanmeldung',
        code: 'REG_BUSINESS',
        parentCode: 'REGISTRATION',
        parentName: 'Registrierungsnachweis',
        multiOccurrence: false,
        validityPeriod: 120,
        designationMandatory: false,
        abstractType: false,
        hasExample: true,
        applicationLevel: 'ORGANISATION',
        certifyingThirdPartyMandatory: false,
        onlyForProjectSubcontractor: false,
        collectableByMandate: false,
        equivalence: null,
        country: COUNTRY.GERMANY
      },
      depositDate: '2019-05-08T11:38:19.097Z',
      organisations: [
        {
          organisationId: 2552,
          fullName: 'Raison',
          country: COUNTRY.GERMANY,
          address: {
            addressLine: 'Ad',
            city: 'Vi',
            postCode: '332211'
          },
          registrationNumber: '33442211',
          depositor: true,
          group: {
            id: 2651,
            country: COUNTRY.GERMANY,
            groupIdentifier: 'DE334422113'
          }
        }
      ],
      validityEnd: '2019-06-10T22:59:59.999Z',
      hasFile: true,
      hasExcelFile: false,
      noticePeriodConfiguration: 'MEDIUM',
      firstNoticePeriod: 30,
      secondNoticePeriod: 15,
      thirdNoticePeriod: 5,
      issueDate: '2019-05-08T00:00:00Z',
      validityStart: '2019-05-08T00:00:00Z',
      certifyingThirdParty: null,
      issuingThirdParty: null,
      rejectionReason: null,
      additionalDesignation: '',
      subjectToObligation: true,
      collectableByMandate: false,
      collectionMandateEnabled: false,
      toFillinOnline: false,
      toSignOnline: false,
      dossiers: [
        {
          type: 'LEGAL',
          client: null,
          project: null,
          business: null
        }
      ],
      unpublished: true,
      overallStatusDocument: false
    },
    {
      uid: '087ee68a-1212-47d4-a422-bdb9bded9bc9',
      groupLevel: false,
      state: 'VALID',
      type: {
        documentTypeId: 4,
        name: 'Gewerbeanmeldung',
        code: 'REG_BUSINESS',
        parentCode: 'REGISTRATION',
        parentName: 'Registrierungsnachweis',
        multiOccurrence: false,
        validityPeriod: 120,
        designationMandatory: false,
        abstractType: false,
        hasExample: true,
        applicationLevel: 'ORGANISATION',
        certifyingThirdPartyMandatory: false,
        onlyForProjectSubcontractor: false,
        collectableByMandate: false,
        equivalence: null,
        country: COUNTRY.GERMANY
      },
      depositDate: '2019-05-08T11:38:19.097Z',
      organisations: [
        {
          organisationId: 2552,
          fullName: 'Raison',
          country: COUNTRY.GERMANY,
          address: {
            addressLine: 'Ad',
            city: 'Vi',
            postCode: '332211'
          },
          registrationNumber: '33442211',
          depositor: true,
          group: {
            id: 2651,
            country: COUNTRY.GERMANY,
            groupIdentifier: 'DE334422113'
          }
        }
      ],
      validityEnd: '2019-10-12T22:59:59.999Z',
      hasFile: true,
      hasExcelFile: false,
      noticePeriodConfiguration: 'MEDIUM',
      firstNoticePeriod: 30,
      secondNoticePeriod: 15,
      thirdNoticePeriod: 5,
      issueDate: '2019-05-08T00:00:00Z',
      validityStart: '2019-05-08T00:00:00Z',
      certifyingThirdParty: null,
      issuingThirdParty: null,
      rejectionReason: null,
      additionalDesignation: '',
      subjectToObligation: true,
      collectableByMandate: false,
      collectionMandateEnabled: false,
      toFillinOnline: false,
      toSignOnline: false,
      dossiers: [
        {
          type: 'LEGAL',
          client: null,
          project: null,
          business: null
        }
      ],
      unpublished: true,
      overallStatusDocument: false
    },
    {
      uid: '2d6480bc-096f-4c99-9aa2-95d7c71f40cb',
      groupLevel: false,
      state: 'VALID',
      type: {
        documentTypeId: 4,
        name: 'Gewerbeanmeldung',
        code: 'REG_BUSINESS',
        parentCode: 'REGISTRATION',
        parentName: 'Registrierungsnachweis',
        multiOccurrence: false,
        validityPeriod: 120,
        designationMandatory: false,
        abstractType: false,
        hasExample: true,
        applicationLevel: 'ORGANISATION',
        certifyingThirdPartyMandatory: false,
        onlyForProjectSubcontractor: false,
        collectableByMandate: false,
        equivalence: null,
        country: COUNTRY.GERMANY
      },
      depositDate: '2019-05-08T11:38:19.097Z',
      organisations: [
        {
          organisationId: 2552,
          fullName: 'Raison',
          country: COUNTRY.GERMANY,
          address: {
            addressLine: 'Ad',
            city: 'Vi',
            postCode: '332211'
          },
          registrationNumber: '33442211',
          depositor: true,
          group: {
            id: 2651,
            country: COUNTRY.GERMANY,
            groupIdentifier: 'DE334422113'
          }
        }
      ],
      validityEnd: '2019-06-10T22:59:59.999Z',
      hasFile: true,
      hasExcelFile: false,
      noticePeriodConfiguration: 'MEDIUM',
      firstNoticePeriod: 30,
      secondNoticePeriod: 15,
      thirdNoticePeriod: 5,
      issueDate: '2019-05-08T00:00:00Z',
      validityStart: '2019-05-08T00:00:00Z',
      certifyingThirdParty: null,
      issuingThirdParty: null,
      rejectionReason: null,
      additionalDesignation: '',
      subjectToObligation: true,
      collectableByMandate: false,
      collectionMandateEnabled: false,
      toFillinOnline: false,
      toSignOnline: false,
      dossiers: [
        {
          type: 'LEGAL',
          client: null,
          project: null,
          business: null
        }
      ],
      unpublished: true,
      overallStatusDocument: false
    },
    {
      uid: '7c4e9150-0922-4992-b071-c4669f488ed5',
      groupLevel: false,
      state: 'VALID',
      type: {
        documentTypeId: 4,
        name: 'Gewerbeanmeldung',
        code: 'REG_BUSINESS',
        parentCode: 'REGISTRATION',
        parentName: 'Registrierungsnachweis',
        multiOccurrence: false,
        validityPeriod: 120,
        designationMandatory: false,
        abstractType: false,
        hasExample: true,
        applicationLevel: 'ORGANISATION',
        certifyingThirdPartyMandatory: false,
        onlyForProjectSubcontractor: false,
        collectableByMandate: false,
        equivalence: null,
        country: COUNTRY.GERMANY
      },
      depositDate: '2019-05-08T11:38:19.097Z',
      organisations: [
        {
          organisationId: 2552,
          fullName: 'Raison',
          country: COUNTRY.GERMANY,
          address: {
            addressLine: 'Ad',
            city: 'Vi',
            postCode: '332211'
          },
          registrationNumber: '33442211',
          depositor: true,
          group: {
            id: 2651,
            country: COUNTRY.GERMANY,
            groupIdentifier: 'DE334422113'
          }
        }
      ],
      validityEnd: '2019-06-10T22:59:59.999Z',
      hasFile: true,
      hasExcelFile: false,
      noticePeriodConfiguration: 'MEDIUM',
      firstNoticePeriod: 30,
      secondNoticePeriod: 15,
      thirdNoticePeriod: 5,
      issueDate: '2019-05-08T00:00:00Z',
      validityStart: '2019-05-08T00:00:00Z',
      certifyingThirdParty: null,
      issuingThirdParty: null,
      rejectionReason: null,
      additionalDesignation: '',
      subjectToObligation: true,
      collectableByMandate: false,
      collectionMandateEnabled: false,
      toFillinOnline: false,
      toSignOnline: false,
      dossiers: [
        {
          type: 'LEGAL',
          client: null,
          project: null,
          business: null
        }
      ],
      unpublished: true,
      overallStatusDocument: false
    },
    {
      uid: '3d4be626-c4e7-471b-921c-9e034fb9e7f4',
      groupLevel: false,
      state: 'VALID',
      type: {
        documentTypeId: 4,
        name: 'Gewerbeanmeldung',
        code: 'REG_BUSINESS',
        parentCode: 'REGISTRATION',
        parentName: 'Registrierungsnachweis',
        multiOccurrence: false,
        validityPeriod: 120,
        designationMandatory: false,
        abstractType: false,
        hasExample: true,
        applicationLevel: 'ORGANISATION',
        certifyingThirdPartyMandatory: false,
        onlyForProjectSubcontractor: false,
        collectableByMandate: false,
        equivalence: null,
        country: COUNTRY.GERMANY
      },
      depositDate: '2019-05-08T11:38:19.097Z',
      organisations: [
        {
          organisationId: 2552,
          fullName: 'Raison',
          country: COUNTRY.GERMANY,
          address: {
            addressLine: 'Ad',
            city: 'Vi',
            postCode: '332211'
          },
          registrationNumber: '33442211',
          depositor: true,
          group: {
            id: 2651,
            country: COUNTRY.GERMANY,
            groupIdentifier: 'DE334422113'
          }
        }
      ],
      validityEnd: '2019-06-10T22:59:59.999Z',
      hasFile: true,
      hasExcelFile: false,
      noticePeriodConfiguration: 'MEDIUM',
      firstNoticePeriod: 30,
      secondNoticePeriod: 15,
      thirdNoticePeriod: 5,
      issueDate: '2019-05-08T00:00:00Z',
      validityStart: '2019-05-08T00:00:00Z',
      certifyingThirdParty: null,
      issuingThirdParty: null,
      rejectionReason: null,
      additionalDesignation: '',
      subjectToObligation: true,
      collectableByMandate: false,
      collectionMandateEnabled: false,
      toFillinOnline: false,
      toSignOnline: false,
      dossiers: [
        {
          type: 'LEGAL',
          client: null,
          project: null,
          business: null
        }
      ],
      unpublished: true,
      overallStatusDocument: false
    },
    {
      uid: '90f03948-658d-44d4-b718-0ee8c5a96644',
      groupLevel: false,
      state: 'VALID',
      type: {
        documentTypeId: 6,
        name: 'Eintragung HWK',
        code: 'REG_ARTISAN',
        parentCode: 'REGISTRATION',
        parentName: 'Registrierungsnachweis',
        multiOccurrence: false,
        validityPeriod: 12,
        designationMandatory: false,
        abstractType: false,
        hasExample: true,
        applicationLevel: 'ORGANISATION',
        certifyingThirdPartyMandatory: false,
        onlyForProjectSubcontractor: false,
        collectableByMandate: false,
        equivalence: {
          code: 'DE_REG',
          rule: 'UNIQUE'
        },
        country: COUNTRY.GERMANY
      },
      depositDate: '2019-05-08T11:39:37.913Z',
      organisations: [
        {
          organisationId: 2552,
          fullName: 'Raison',
          country: COUNTRY.GERMANY,
          address: {
            addressLine: 'Ad',
            city: 'Vi',
            postCode: '332211'
          },
          registrationNumber: '33442211',
          depositor: true,
          group: {
            id: 2651,
            country: COUNTRY.GERMANY,
            groupIdentifier: 'DE334422113'
          }
        }
      ],
      validityEnd: '2020-05-08T23:59:59Z',
      hasFile: true,
      hasExcelFile: false,
      noticePeriodConfiguration: 'MEDIUM',
      firstNoticePeriod: 30,
      secondNoticePeriod: 15,
      thirdNoticePeriod: 5,
      issueDate: '2019-05-08T00:00:00Z',
      validityStart: '2019-05-08T00:00:00Z',
      certifyingThirdParty: null,
      issuingThirdParty: null,
      rejectionReason: null,
      additionalDesignation: '',
      subjectToObligation: true,
      collectableByMandate: false,
      collectionMandateEnabled: false,
      toFillinOnline: false,
      toSignOnline: false,
      dossiers: [
        {
          type: 'LEGAL',
          client: null,
          project: null,
          business: null
        }
      ],
      unpublished: true,
      overallStatusDocument: false
    },
    {
      uid: 'cf41ca08-7038-49e2-8760-da5893d8cac3',
      groupLevel: false,
      state: 'VALID',
      type: {
        documentTypeId: 6,
        name: 'Eintragung HWK',
        code: 'REG_ARTISAN',
        parentCode: 'REGISTRATION',
        parentName: 'Registrierungsnachweis',
        multiOccurrence: false,
        validityPeriod: 12,
        designationMandatory: false,
        abstractType: false,
        hasExample: true,
        applicationLevel: 'ORGANISATION',
        certifyingThirdPartyMandatory: false,
        onlyForProjectSubcontractor: false,
        collectableByMandate: false,
        equivalence: {
          code: 'DE_REG',
          rule: 'UNIQUE'
        },
        country: COUNTRY.GERMANY
      },
      depositDate: '2019-05-08T11:39:37.913Z',
      organisations: [
        {
          organisationId: 2552,
          fullName: 'Raison',
          country: COUNTRY.GERMANY,
          address: {
            addressLine: 'Ad',
            city: 'Vi',
            postCode: '332211'
          },
          registrationNumber: '33442211',
          depositor: true,
          group: {
            id: 2651,
            country: COUNTRY.GERMANY,
            groupIdentifier: 'DE334422113'
          }
        }
      ],
      validityEnd: '2019-06-10T22:59:59.999Z',
      hasFile: true,
      hasExcelFile: false,
      noticePeriodConfiguration: 'MEDIUM',
      firstNoticePeriod: 30,
      secondNoticePeriod: 15,
      thirdNoticePeriod: 5,
      issueDate: '2019-05-08T00:00:00Z',
      validityStart: '2019-05-08T00:00:00Z',
      certifyingThirdParty: null,
      issuingThirdParty: null,
      rejectionReason: null,
      additionalDesignation: '',
      subjectToObligation: true,
      collectableByMandate: false,
      collectionMandateEnabled: false,
      toFillinOnline: false,
      toSignOnline: false,
      dossiers: [
        {
          type: 'LEGAL',
          client: null,
          project: null,
          business: null
        }
      ],
      unpublished: true,
      overallStatusDocument: false
    },
    {
      uid: 'b59fbcc4-ee7d-4f77-94dd-f3f6cb50f0fb',
      groupLevel: false,
      state: 'VALID',
      type: {
        documentTypeId: 6,
        name: 'Eintragung HWK',
        code: 'REG_ARTISAN',
        parentCode: 'REGISTRATION',
        parentName: 'Registrierungsnachweis',
        multiOccurrence: false,
        validityPeriod: 12,
        designationMandatory: false,
        abstractType: false,
        hasExample: true,
        applicationLevel: 'ORGANISATION',
        certifyingThirdPartyMandatory: false,
        onlyForProjectSubcontractor: false,
        collectableByMandate: false,
        equivalence: {
          code: 'DE_REG',
          rule: 'UNIQUE'
        },
        country: COUNTRY.GERMANY
      },
      depositDate: '2019-05-08T11:39:37.913Z',
      organisations: [
        {
          organisationId: 2552,
          fullName: 'Raison',
          country: COUNTRY.GERMANY,
          address: {
            addressLine: 'Ad',
            city: 'Vi',
            postCode: '332211'
          },
          registrationNumber: '33442211',
          depositor: true,
          group: {
            id: 2651,
            country: COUNTRY.GERMANY,
            groupIdentifier: 'DE334422113'
          }
        }
      ],
      validityEnd: '2019-06-10T22:59:59.999Z',
      hasFile: true,
      hasExcelFile: false,
      noticePeriodConfiguration: 'MEDIUM',
      firstNoticePeriod: 30,
      secondNoticePeriod: 15,
      thirdNoticePeriod: 5,
      issueDate: '2019-05-08T00:00:00Z',
      validityStart: '2019-05-08T00:00:00Z',
      certifyingThirdParty: null,
      issuingThirdParty: null,
      rejectionReason: null,
      additionalDesignation: '',
      subjectToObligation: true,
      collectableByMandate: false,
      collectionMandateEnabled: false,
      toFillinOnline: false,
      toSignOnline: false,
      dossiers: [
        {
          type: 'LEGAL',
          client: null,
          project: null,
          business: null
        }
      ],
      unpublished: true,
      overallStatusDocument: false
    }
  ]
);

// This deconstruction while we refacto api-ecm (removing file binaries nuxeo calls)
// @See PLATINT-4114
const archivedDocumentsWithoutFilesInDb = archivedDocumentsInDb.map(doc => {
  const {state, uid, validityStart, validityEnd, type} = doc;
  const {name, code} = type;
  return {
    state,
    uid,
    validityStart,
    validityEnd,
    type: {
      name, code
    }
  };
});

const projectSharedDocuments = [
  {
    uid: 'f81d4fae-9dec-12d8-a765-00z6491e6bd7',
    depositDate: '2019-06-10T10:10:26.426Z',
    additionalDesignation: 'This is a project shared doc',
    hasFile: true,
    project: {
      country: COUNTRY.FRANCE,
      id: 1,
      name: 'Project 1',
      ownerOrganisation: {
        id: 1,
        fullName: 'Organisation 1',
        registrationNumber: 2822782
      },
      projectStatus: 'ACTIVE'
    },
    type: {
      code: 'GENERIC_PROJECT_SHARED_FR',
      name: 'Bannette'
    },
    state: 'VALID'
  },
  {
    uid: 'f81d4fae-9dez-12d8-a765-00z8291e6bk9',
    depositDate: '2019-06-13T10:12:26.426Z',
    additionalDesignation: '',
    hasFile: true,
    project: {
      country: COUNTRY.FRANCE,
      id: 1,
      name: 'Project 1',
      ownerOrganisation: {
        id: 1,
        fullName: 'Organisation 1',
        registrationNumber: 2822782
      },
      projectStatus: 'ACTIVE'
    },
    type: {
      code: 'CDC_NOMINATIF',
      name: 'Cahier des charges'
    },
    state: 'MISSING'
  }
];

const dossiersStateCount = [
  {
    dossierState: 'VALID',
    count: 1
  },
  {
    dossierState: 'EMPTY',
    count: 0
  },
  {
    dossierState: 'INVALID',
    count: 2
  },
  {
    dossierState: 'WARNING',
    count: 0
  }
];

const documentsPerState = [
  {
    documentState: 'VALID',
    count: 1
  },
  {
    documentState: 'AWAITING_SIGNATURE',
    count: 0
  },
  {
    documentState: 'SIGNED',
    count: 0
  },
  {
    documentState: 'AWAITING_VALIDATION',
    count: 0
  },
  {
    documentState: 'REJECTED',
    count: 1
  },
  {
    documentState: 'AWAITING_GATHERING',
    count: 0
  },
  {
    documentState: 'EXPIRED',
    count: 0
  },
  {
    documentState: 'ALMOST_EXPIRED',
    count: 0
  },
  {
    documentState: 'MISSING',
    count: 1
  },
  {
    documentState: 'NOT_APPLICABLE',
    count: 0
  }
];

export default class FakeDocumentService {
  search() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(documentsInDb);
      }, 0);
    });
  }

  searchByClient() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(documentsInDb.filter((organisation, index) => index % 2 === 1));
      }, 0);
    });
  }

  searchOfSubcontractor() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(documentsInDb);
      }, 0);
    });
  }

  searchByProject() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(documentsInDb);
      }, 0);
    });
  }

  searchByProjectOfSubcontractor() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(documentsInDb);
      }, 0);
    });
  }

  getDossierState(organisationId) {
    return new Promise(resolve => {
      setTimeout(() => {
        if (organisationId % 4 === 1) {
          resolve({
            dossierState: DOSSIER_STATE.INVALID
          });
          return;
        }

        if (organisationId % 4 === 2) {
          resolve({
            dossierState: DOSSIER_STATE.WARNING
          });
          return;
        }

        if (organisationId % 4 === 3) {
          resolve({
            dossierState: DOSSIER_STATE.EMPTY
          });
          return;
        }

        resolve({
          dossierState: DOSSIER_STATE.VALID
        });
      }, 0);
    });
  }

  getDossierStateDetails(organisationId) {
    return new Promise(resolve => {
      setTimeout(() => {
        if (organisationId % 4 === 1) {
          resolve({
            dossierState: DOSSIER_STATE.INVALID,
            invalidDocuments: [
              documentsInDb[0]
            ],
            almostExpiredDocuments: []
          });
          return;
        }

        if (organisationId % 4 === 2) {
          resolve({
            dossierState: DOSSIER_STATE.WARNING,
            invalidDocuments: [],
            almostExpiredDocuments: [
              documentsInDb[0]
            ]
          });
          return;
        }

        if (organisationId % 4 === 3) {
          resolve({
            dossierState: DOSSIER_STATE.EMPTY,
            invalidDocuments: [],
            almostExpiredDocuments: []
          });
          return;
        }

        resolve({
          dossierState: DOSSIER_STATE.VALID,
          invalidDocuments: [],
          almostExpiredDocuments: []
        });
      }, 0);
    });
  }

  getDossierStateForGlobalDashboard(organisationId) {
    return this.getDossierState(organisationId);
  }

  getInterventionDossierState(interventionId) {
    return new Promise(resolve => {
      setTimeout(() => {
        if (interventionId % 4 === 1) {
          resolve({dossierState: 'INVALID'});
          return;
        }

        if (interventionId % 4 === 2) {
          resolve({dossierState: 'WARNING'});
          return;
        }

        if (interventionId % 4 === 3) {
          resolve({dossierState: 'UNKNOWN'});
          return;
        }

        resolve({dossierState: 'VALID'});
      }, 0);
    });
  }

  getFileUrl(documentId) {
    return `http://localhost:4000/CGUV_ALG.pdf?documentId=${documentId}`;
  }

  getFileProofUrl(documentId) {
    return `http://localhost:4000/CGUV_ALG.pdf?documentId=${documentId}`;
  }

  getDossierPdfUrl(organisationId, country) {
    return `http://localhost:4000/CGUV_ALG.pdf?organisationId=${organisationId}&country=${country}`;
  }

  getDossierZipUrl(organisationId, country) {
    return `https://github.com/AttestationLegale/front-onceforall/archive/dev.zip?organisationId=${organisationId}&country=${country}`;
  }

  getDossierArchivesZipUrl() {
    return 'https://github.com/AttestationLegale/front-onceforall/archive/dev.zip';
  }

  getDossierForClientPdfUrl(organisationId, clientId) {
    return `http://localhost:4000/CGUV_ALG.pdf?organisationId=${organisationId}&clientId=${clientId}`;
  }

  getDossierForClientZipUrl() {
    return 'https://github.com/AttestationLegale/front-onceforall/archive/dev.zip';
  }

  getDossierOfSubcontractorPdfUrl(organisationId, subcontractorId, country) {
    return `http://localhost:4000/CGUV_ALG.pdf?organisationId=${organisationId}&subcontractorId=${subcontractorId}&country=${country}`;
  }

  getDossierOfSubcontractorZipUrl(organisationId, subcontractorId, country) {
    return `https://github.com/AttestationLegale/front-onceforall/archive/dev.zip?organisationId=${organisationId}&subcontractorId=${subcontractorId}&country=${country}`;
  }

  getDossierArchivesOfSubcontractorZipUrl() {
    return 'https://github.com/AttestationLegale/front-onceforall/archive/dev.zip';
  }

  getProjectDossierPdfUrl(interventionId) {
    return `http://localhost:4000/CGUV_ALG.pdf?interventionId=${interventionId}&locale=fr'`;
  }

  getProjectDossierZipUrl() {
    return 'https://github.com/AttestationLegale/front-onceforall/archive/dev.zip';
  }

  getProjectDossierOfSubcontractorPdfUrl(interventionId, subcontractorId, organisationId) {
    return `http://localhost:4000/CGUV_ALG.pdf?interventionId=${interventionId}&subcontractorId=${subcontractorId}&organisationId=${organisationId}&locale=fr`;
  }

  getProjectDossierOfSubcontractorZipUrl() {
    return 'https://github.com/AttestationLegale/front-onceforall/archive/dev.zip';
  }

  downloadDossierOverview(organisationId, locale, country) {
    return `http://localhost:3000/resources/dossier-overview.pdf?organisationId=${organisationId}&locale=${locale}&country=${country}`;
  }

  downloadDossierOverviewProject() {
    return 'http://localhost:3000/resources/dossier-overview.pdf';
  }

  getProjectOverviewReportDownloadUrl() {
    return 'http://localhost:3000/resources/dossier-overview.pdf';
  }

  getExportUrl() {
    return 'http://localhost:3000/resources/dossier-overview.pdf';
  }

  submitNewDocument(uid, file, info) {
    const newDocument = {...documentsInDb.find(document => document.uid === uid)};
    newDocument.uid = String(Math.floor((Math.random() * 10000000000000) + 1));
    if (info.documentTypeCode === 'ADD_SWORN_STAT') {
      newDocument.state = 'AWAITING_SIGNATURE';
      newDocument.depositDate = null;
      newDocument.validityEnd = null;
      newDocument.issueDate = null;
      newDocument.validityStart = null;
      newDocument.hasFile = false;
      newDocument.md5 = null;
    } else {
      newDocument.hasFile = true;
      newDocument.state = 'AWAITING_VALIDATION';
    }

    documentsInDb.push(newDocument);

    return new Promise(resolve => {
      setTimeout(() => {
        resolve(uid, file, info);
      }, 0);
    });
  }

  duplicateDocument(documentId) {
    const documentToCopy = {...documentsInDb.find(documentInDB => documentInDB.uid === documentId)};
    documentToCopy.uid = String(Math.floor((Math.random() * 10000000000000) + 1));
    documentToCopy.state = DOCUMENT_STATE.MISSING;
    documentToCopy.hasFile = false;
    documentToCopy.validityEnd = undefined;
    documentsInDb.push(documentToCopy);
    return Promise.resolve({});
  }

  updateAdditionalDesignation(uid, additionalDesignation) {
    const document = documentsInDb.find(documentItem => documentItem.uid === uid);
    document.additionalDesignation = additionalDesignation;
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 0);
    });
  }

  deleteDocument(organisationId, documentToDelete) {
    documentsInDb = documentsInDb.filter(document => document.uid !== documentToDelete.uid);
    return Promise.resolve();
  }

  findOne(documentId) {
    return Promise.resolve(documentsInDb.find(document => document.uid === documentId));
  }

  getDossierCountPerState() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(dossiersStateCount);
      }, 0);
    });
  }

  getDocumentsCountPerState() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(documentsPerState);
      }, 0);
    });
  }

  getArchivedDocuments() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(archivedDocumentsWithoutFilesInDb);
      }, 0);
    });
  }

  getArchivedDocumentsOfSubcontractor() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(archivedDocumentsInDb);
      }, 0);
    });
  }

  getDocumentArchivesByIntervention() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(archivedDocumentsInDb);
      }, 0);
    });
  }

  getProjectSharedDocuments() {
    return Promise.resolve(projectSharedDocuments);
  }

  submitProjectSharedDocument() {
    return Promise.resolve();
  }

  createDocumentRemindersRequest() {
    return Promise.resolve();
  }

  createDocumentExport() {
    return Promise.resolve();
  }

  getDocumentsAndDossierCountPerStateByUser() {
    return Promise.resolve({
      dossierStateCount: [
        {
          dossierState: DOSSIER_STATE.VALID,
          count: 4
        },
        {
          dossierState: DOSSIER_STATE.EMPTY,
          count: 2
        },
        {
          dossierState: DOSSIER_STATE.INVALID,
          count: 1
        },
        {
          dossierState: DOSSIER_STATE.WARNING,
          count: 0
        }
      ],
      documentStateCount: [
        {
          documentState: DOCUMENT_STATE.VALID,
          count: 2
        },
        {
          documentState: DOCUMENT_STATE.AWAITING_SIGNATURE,
          count: 0
        },
        {
          documentState: DOCUMENT_STATE.SIGNED,
          count: 0
        },
        {
          documentState: DOCUMENT_STATE.AWAITING_VALIDATION,
          count: 1
        },
        {
          documentState: DOCUMENT_STATE.REJECTED,
          count: 1
        },
        {
          documentState: DOCUMENT_STATE.AWAITING_GATHERING,
          count: 0
        },
        {
          documentState: DOCUMENT_STATE.EXPIRED,
          count: 0
        },
        {
          documentState: DOCUMENT_STATE.ALMOST_EXPIRED,
          count: 1
        },
        {
          documentState: DOCUMENT_STATE.MISSING,
          count: 1
        },
        {
          documentState: DOCUMENT_STATE.NOT_APPLICABLE,
          count: 0
        }
      ]
    });
  }

  addDocument() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 0);
    });
  }

  requireProjectSpecificDocument() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 0);
    });
  }

  getNewVersionToSign() {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({uid: 'newUID'});
      }, 0);
    });
  }

  getAllDocumentValidVersions() {
    return new Promise(resolve => {
      setTimeout(() => {
        const response = [...archivedDocumentsInDb];
        response.splice(2, 0, documentsInDb.find(doc => doc.uid === 'f81d4fae-7dec-11d0-a765-00a0c91e6bfa'));
        resolve(response);
      }, 0);
    });
  }

  getAllDocumentValidVersionsBySubcontractor() {
    return new Promise(resolve => {
      setTimeout(() => {
        const response = [...archivedDocumentsInDb];
        response.splice(2, 0, documentsInDb.find(doc => doc.uid === 'f81d4fae-7dec-11d0-a765-00a0c91e6bfa'));
        resolve(response);
      }, 0);
    });
  }
}
